import useMid from '@tapp/composables/src/runtime/composables/useMid';
import { tryUseNuxtApp, useRequestURL } from '#app';

import { getClientContextHeaders } from '../ClientContext/ClientContext';

/**
 * The headers every FE → BE call has to carry:
 *
 * - `X-Mid-Token` — most back-end endpoints require it, and the SSR response cache refuses to cache
 *   a request without one.
 * - `X-Client-*` — the URL context the back-end uses to register on which page a request originated.
 *
 * Returns nothing when there is no Nuxt context — e.g. called from a timer after the request
 * finished — since there is neither MID state nor a request URL to read then.
 */
export function getRequestContextHeaders(): Record<string, string> {
  if (!tryUseNuxtApp()) return {};

  const headers: Record<string, string> = { 'X-Mid-Token': useMid().mid.value };

  try {
    Object.assign(headers, getClientContextHeaders(useRequestURL()));
  } catch {
    // missing context must never fail the request.
  }

  return headers;
}
